import { useState } from 'react'
import { createPortal } from 'react-dom'
import LGPDTermsContent from './LGPDTermsContent'

const LGPDConsentStep = ({ onNext, onBack, loading, error }) => {
  const [accepted, setAccepted] = useState(false)
  const [showModal, setShowModal] = useState(false)

  return (
    <div className="space-y-6">
      {/* Header with shield icon */}
      <div className="text-center mb-6">
        <div className="flex justify-center mb-4">
          <div className="relative w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-blue-500/20 to-cyan-500/20 border border-cyan-500/30">
            <svg className="w-8 h-8 text-cyan-500" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
            </svg>
          </div>
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">LGPD</h2>
        <p className="text-sm text-cyan-400">Termo de ciência e consentimento</p>
      </div>

      {error && (
        <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3 text-sm text-red-400">
          {error}
        </div>
      )}

      {/* Info text */}
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 text-sm text-gray-700 dark:text-gray-300">
        <p>Para continuar com a ativação da empresa, você precisa ler e aceitar os termos da LGPD.</p>
      </div>

      {/* Acceptance checkbox with link to modal */}
      <div className="flex items-start space-x-3 bg-white/5 border border-white/10 rounded-lg p-4">
        <input
          type="checkbox"
          id="lgpd-consent"
          checked={accepted}
          onChange={(e) => setAccepted(e.target.checked)}
          className="w-5 h-5 mt-1 rounded accent-cyan-500 cursor-pointer flex-shrink-0"
        />
        <label htmlFor="lgpd-consent" className="text-sm text-gray-300 cursor-pointer">
          Declaro ter lido, compreendido e concordado integralmente com os presentes{' '}
          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="text-cyan-400 hover:text-cyan-300 underline font-medium transition-colors"
          >
            termos
          </button>
          {' '}da LGPD.
        </label>
      </div>

      {/* Navigation buttons */}
      <div className="flex gap-3 pt-4">
        <button
          onClick={onBack}
          disabled={loading}
          className="flex-1 px-4 py-2.5 border border-white/20 text-white rounded-lg hover:bg-white/5 transition-colors disabled:opacity-50"
        >
          Voltar
        </button>
        <button
          onClick={onNext}
          disabled={!accepted || loading}
          className="flex-1 px-4 py-2.5 bg-cyan-600 hover:bg-cyan-700 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Carregando...' : 'Próximo'}
        </button>
      </div>

      {/* Terms Popup Modal - Right Sidebar using Portal */}
      {showModal && createPortal(
        <>
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
            onClick={() => setShowModal(false)}
          />

          {/* Right Sidebar Panel */}
          <div className="fixed right-0 top-0 h-screen w-full max-w-2xl bg-white dark:bg-gray-800 shadow-2xl z-50 flex flex-col animate-slide-in-right">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
              <h2 className="text-lg font-bold text-gray-900 dark:text-white">
                Termo LGPD
              </h2>
              <button
                onClick={() => setShowModal(false)}
                className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition text-gray-600 dark:text-gray-400"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Content with scroll */}
            <div className="flex-1 overflow-y-auto p-6">
              <LGPDTermsContent />
            </div>
          </div>
        </>,
        document.body
      )}
    </div>
  )
}

export default LGPDConsentStep
